import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { SnackbarService } from './snackbar-service';
import { ScreenService } from 'src/app/common/services/screen.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private snackBar: SnackbarService = inject(SnackbarService);
  private screenService: ScreenService = inject(ScreenService);

  private static isDisabled4xxIntercept = false;

  public static async runWithDisable4xxIntercept<TResp>(promiseCall: () => Promise<TResp>) {
    HttpErrorInterceptor.isDisabled4xxIntercept = true;
    try {
      return await promiseCall();
    } finally {
      HttpErrorInterceptor.isDisabled4xxIntercept = false;
    }
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.screenService.startLoading();
    return next.handle(request)
      .pipe(
        tap(
          (_: HttpEvent<any>) => { },
          (error: HttpErrorResponse) => {
            if (HttpErrorInterceptor.isDisabled4xxIntercept && 400 <= error.status && error.status < 500)
              return;

            const reader: FileReader = new FileReader();
            reader.onloadend = () => {
              this.showErrorSnackbar('' + reader.result, undefined);
            };

            if (error.error.type === 'error') {
              this.showErrorSnackbar(error.message, undefined);
            } else {
              reader.readAsText(error.error);
            }
          }
        ),
        finalize(() => {
          this.screenService.stopLoading();
        })
      );
  }

  private showErrorSnackbar(message: string, traceUrl: string | undefined) {
    const actionLabel = traceUrl ? 'Open trace' : undefined;
    const snackBarRef = this.snackBar.snackBar.open('Error ' + message, actionLabel, { duration: 60000 });
    if (traceUrl) {
      snackBarRef.onAction().subscribe(() => window.open(traceUrl));
    }
  }
}
